export default __webpack_public_path__ + "static/media/element_4.af4a1a7c.webp";